import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Layout from "@/components/layout/Layout";
import api from "@/lib/api";
import { useShop } from "@/lib/useShop";
import { NotFound } from "@/components/simple/product/Fields";
import PrintBody from "./PrintBody";

/**
 * /print/:slug — one Flyers & Print product in the full-screen designer (Phase 10). The URL names a group
 * (`/print/flyers`), a config slug (`/print/menus-waterproof`) or a shop SKU; `?store=` keeps the shop's prices.
 */
export default function PrintProductPage() {
    const { slug: key } = useParams();
    const { shopSlug } = useShop();
    const [data, setData] = useState(null);
    const [missing, setMissing] = useState(false);
    const [variantSlug, setVariantSlug] = useState(null);

    useEffect(() => {
        setData(null); setMissing(false); setVariantSlug(null);
        api.get(`/print/products/${key}`, { params: shopSlug ? { store: shopSlug } : {} })
            .then(({ data }) => setData(data)).catch(() => setMissing(true));
    }, [key, shopSlug]);

    const tile = data?.tile;
    const variant = tile ? (tile.variants.find((v) => v.slug === variantSlug) || tile.variants.find((v) => v.slug === key || v.sku === key) || tile.variants[0]) : null;

    if (missing) return <Layout designer><div className="mx-auto max-w-3xl px-4 py-24 text-center" data-testid="print-missing"><NotFound store={data?.store} /><Link to="/print" className="mt-4 inline-block underline">Back to Flyers &amp; Print</Link></div></Layout>;
    if (!data) return <Layout designer><div className="flex min-h-[60vh] items-center justify-center text-zinc-400" data-testid="print-loading"><Loader2 className="animate-spin" /></div></Layout>;
    if (!tile || !variant) return (
        <Layout designer>
            <div className="mx-auto max-w-3xl px-4 py-24 text-center" data-testid="print-empty">
                <h1 className="font-display text-3xl font-black">This shop doesn't sell that yet.</h1>
                <Link to="/print" className="mt-4 inline-block underline">Back to Flyers &amp; Print</Link>
            </div>
        </Layout>
    );

    return (
        <Layout designer title={tile.label}>
            <PrintBody key={tile.key} tile={tile} variant={variant} onVariant={setVariantSlug} store={data.store} cleanupFee={data.cleanup_fee} />
        </Layout>
    );
}
